import React, { useEffect } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import UploadOfflineReadingForm from "../workers/upload-ofline-reading-form/UploadOflineReadingForm";
import ArchiveCard from "../workers/workers-details/worker-details-modals/WorkerArchiveCard";
import SlaAgreementCard from "../clients/sla-card/SlaAgrementCard";
import AttributesCard from "../clients/attributes-card/AttributesCard";
import AdminForm from "../workers/admin-details-form/AdminForm";
import SlaCard from "../clients/sla-card/SlaCard";
import ClientForm from "../clients/client-form/ClientForm";
import RoleForm from "../roles/create-role/RoleForm";
import SlaAgreementDisable from "../clients/sla-card/SlaDisable";
import { AppDispatch, getOrganizationAdminRequest } from "@src/redux/index";
import { useDispatch } from "react-redux";
import UnArchiveCard from "../workers/workers-details/worker-details-modals/WorkerUnArchiveCard";

interface DynamicFormModalProps {
  visible: boolean;
  onCancel: () => void;
  formType: string;
  title: string;
  mutationType?: "edit" | "add";
  worker?: any;
  client?: any;
  setModalVisible?: (visible: boolean) => void;
  formValues?: any;
  item?: any;
}

const DynamicFormModal: React.FC<DynamicFormModalProps> = ({
  visible,
  onCancel,
  formType,
  title,
  client,
  mutationType,
  setModalVisible,
  item,
  formValues
}) => {
  const navigate = useNavigate();

  const renderFormContent = () => {
    switch (formType) {
      case "offline_readings":
        return <UploadOfflineReadingForm onCancel={onCancel} client={item} />;
      case "archive":
        return (
          <ArchiveCard
            name={item?.name ?? "Default Name"}
            onCancel={onCancel}
            worker={item} />);

      case "un_archive":
        return (
          <UnArchiveCard
            name={item?.name ?? "Default Name"}
            onCancel={onCancel}
            worker={item} />);

      case "sla":
        return <SlaAgreementCard onCancel={onCancel} client={item} />;
      case "attributes":
        return <AttributesCard onCancel={onCancel} client={item} />;
      case "kits":
        navigate(`/settings/client-kits/${item.id}/${item.groupId}`);
        return null;
      case "admin":
        return (
          <AdminForm
            mutationType={mutationType || "edit"}
            onCancel={onCancel}
            item={item} />);

      case "sla_agreement":
        return <SlaCard onCancel={onCancel} client={item} />;
      case "sla_agreement_disable":
        return <SlaAgreementDisable onCancel={onCancel} client={item} />;
      case "client":
        navigate(`/settings/client/${item.id}`);
        return null;
      case "roles":
        return (
          <RoleForm
            cardTitle={title}
            onCancel={onCancel}
            mutationType={"edit"}
            roleType={item?.systemUser?.roleList?.[0]?.name}
            record={item}
            setModalVisible={setModalVisible} />);

      default:
        return null;
    }
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={formType.includes("sla") ? 400 : 800}>
      
      {renderFormContent()}
    </Modal>);

};

export default DynamicFormModal;